import { updateSlimSelectDisabled } from 'controllers/dropdown_controller'

document.addEventListener("htmx:beforeRequest", (_event) => {
  const $forms = document.querySelectorAll("[data-disable-elements-on-hx-request]")
  $forms.forEach(($form) => {
    $form.querySelectorAll("button,input,select").forEach((el) => {
      el.dataset.originalDisabled = el.disabled
      el.disabled = true

      if (el.nodeName === "SELECT") {
        updateSlimSelectDisabled(el)
      }
    })
  })

  document.querySelectorAll("[data-disable-on-hx-request]").forEach((el) => {
    el.dataset.originalDisabled = el.classList.contains("-disabled")
    el.classList.add("-disabled-for-htmx")
  })
})

document.addEventListener("htmx:afterSettle", (_event) => {
  const $forms = document.querySelectorAll("[data-disable-elements-on-hx-request]")
  $forms.forEach(($form) => {
    $form.querySelectorAll("button,input,select").forEach((el) => {
      el.disabled = el.dataset.originalDisabled === "true"
      el.removeAttribute("data-original-disabled")
    })
  })

  document.querySelectorAll("[data-disable-on-hx-request]").forEach((el) => {
    if (el.dataset.originalDisabled === "true") {
      el.classList.add("-disabled-for-htmx")
    } else {
      el.classList.remove("-disabled-for-htmx")
    }
    el.removeAttribute("data-original-disabled")
  })
})
